import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row, Alert, Image, Stack } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Button, Dimmer, Divider, Label, Loader, Icon, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Popup, Form as FormSuir, Input as InputSuir  } from "semantic-ui-react";
import ProductCard from "../../component/ProductCard";
import ProductFilterClearance from "../../component/ProductFilterClearance";
import nodata from "../../assets/no_data.png"
import { useMyGlobal } from "../../component/GlobalData";
import { sha256 } from "../../component/utility";
//import { Blog } from "../../component/Blog";
import { seo_meta } from '../../component/seo';
//import SeoHelmet from '../../component/SeoHelmet';

export const ClearancePage = () => {
    const category = useLocation().state
    const path = useLocation().pathname
    const param = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const keyWords = queryParams.get('search')
    const idCustomer = (localStorage.getItem('loginDataRr') !== null) ? JSON.parse(localStorage.getItem('loginDataRr')).id : null
    const [products, setProducts] = useState([])
    const [colorList, setColorList] = useState([])
    const [sizeList, setSizeList] = useState([])
    const { token } = useMyGlobal()
    const [load, setLoad] = useState(true)
    const [loadFilter, setLoadFilter] = useState(false)
    const [hideImageEmpty, setHideImageEmpty] = useState(true)
    const { wishData, isPortrait, windowWidth, categoryAll } = useMyGlobal()
    const [directLinkCat, setDirectLinkCat] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)
    const pagePerLoad = 12
    const [jmlProd, setJmlProd] = useState(pagePerLoad)
    const [loaderProduct, setLoaderProduct] = useState(false)
    const [disableLoad, setDisableLoad] = useState(false)
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);
    const [listBrandonClearance, setListBrandonClearance] = useState([])
    const [listSize, setListSize] = useState([])
    const [searchVal, setSearchVal] = useState('')

    const [filter, setFilter] = useState({
        brand: '',
        size: '',
        color: '',
        priceMin: '',
        priceMax: '',
        search_val: ''
    })

    const [sortConfig, setSortConfig] = useState({
        sort: 'new_arrival'
    })

    const [isFirstLoad, setIsFirstLoad] = useState(true)
    
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const pathSegments = path
        .split('/')
        .filter(segment => segment && isNaN(Number(segment)))
        .map(segment => decodeURIComponent(segment.replace(/-/g, ' ')))

    const EmptyCategory = () => {
        return (
            <Alert variant="secondary" className="text-start mt-5">
                <Alert.Heading>This category does not contain any products!</Alert.Heading>
                <div>
                    This category does not contain items, maybe no items have been added to this category,
                    please click <Link to="/">Back to home</Link> to return to the category menu
                </div>
            </Alert>
        )
    }

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50 && !loaderProduct && hasMore
            ) {
                handleClickLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loaderProduct, hasMore]);

    const getProductList = async ( id_customer, pages, jumlahData) => {
        setLoaderProduct(true)

        const param = new URLSearchParams()
        if (id_customer === null) { id_customer = false }

        param.append('id_customer', id_customer)
        param.append('page', pages)
        param.append('limit', jumlahData)

        param.append('brand', filter.brand || '')
        param.append('size', filter.size || '')
        param.append('color', filter.color || '')
        param.append('price_min', filter.priceMin || '')
        param.append('price_max', filter.priceMax || '')
        param.append('search_val', filter.search_val || '')
        param.append('sort', sortConfig.sort || '')
        
        // Generate temporary token
        const tokenResponse = await axios({
            method: "GET",
            url: `https://hoopsdevteam.com/api_web/controler/codex.php?index=1`,
            headers: {
                'Cfr-Ch-Frm-Fe': 'always'
            },
        });
        const accessToken = tokenResponse.data.data;

        // Request Product CLEARANCE
        await axios({
            method: "POST",
            url: `https://hoopsdevteam.com/api_web/controler/rudrunner/product.php?index=131`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token, // LEGACY - jangan diubah
                'X-Access': accessToken // NEW
            },
            data: param
        })
            .then((response) => {
                let data = []
                let colors = []
                let brand = []
                let size = []

                if (response.data.state == 200) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data
                        data.map((i, d) => i.color.map((x) => colors.push(x)))
                        data.map((i, d) => i.size.map((x) => size.push(x)))

                        if (response.data.data.length > 0) {
                            setLoad(false)
                            setLoadFilter(false)
                            setHideImageEmpty(true)
                        } else {
                            setLoad(false)
                            setLoadFilter(false)
                            setHideImageEmpty(false)
                        }

                        if (pages === 0) {

                            setProducts(data)

                        } else {
                            setProducts(prev => {
                                const filteredData = data.filter(item =>
                                    !prev.some(prevItem => prevItem.id_product === item.id_product)
                                )

                                return [...prev, ...filteredData]
                            })
                        }

                        setHasMore(true)
                    } else {
                        setDisableLoad(true)
                        setHasMore(false)
                    }
                    
                    setColorList(Object.values(colors.reduce((acc, item) => {
                        if (!acc[item.id_color]) acc[item.id_color] = {
                            id_color: item.id_color,
                            color_main: item.color_main,
                            color_secondary: item.color_secondary,
                            color_accent: item.color_accent
                        }

                        return acc
                    }, {})))

                    /*
                    const sizeGroup = [...new Set(size)].map(String)

                    const convertedSizeGroup = sizeGroup.map((value) => {
                        const fractionMatch = value.match(/(\d+)½/);
                        if (fractionMatch) {
                            const wholeNumber = fractionMatch[1] || '0';
                            return `${wholeNumber}.5`;
                        }

                        return value;
                    });

                    const convertedNumericGroup = sizeGroup.map((value) => {
                        const numericValue = !isNaN(parseFloat(value)) ? parseFloat(value) : value;

                        return numericValue;
                    });
                    
                    const sortableValues = convertedNumericGroup.filter(value => typeof value === 'number');
                    const nonSortableValues = convertedNumericGroup.filter(value => typeof value !== 'number');

                    const sortedNumericValues = sortableValues.sort((a, b) => a - b);

                    const finalResult = [...sortedNumericValues, ...nonSortableValues];
                    setSizeList(finalResult);
                    console.log(finalResult);
                    */
                }
            }).finally(() => {
                setLoaderProduct(false)
                setLoad(false)
                setLoadFilter(false)
            })

    }

    const handleClickLoadMore = () => {
        const page = currentPage + pagePerLoad
        setCurrentPage(page)
        getProductList(idCustomer,  page, jmlProd)
    }

    useEffect(() => {

        if (category !== null) {
            setLoad(true)
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])
            
            setListBrandonClearance([])
            setListSize([])
            
            getProductList( idCustomer, 0, jmlProd)
            window.scrollTo(0, 0)
        }
    }, [category, param])

    useEffect(() => {
        if (category === null) {
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])

            getProductList( null, 0, jmlProd)

        }
    }, [path, categoryAll, category])
    
    const getListBrandonClearance = async () => {
        await axios.get(
            "https://hoopsdevteam.com/api_web/controler/rudrunner/listbrand.php?index=2"
        )
        .then(res => {
            if (res.data.state === 200) {
                setListBrandonClearance(res.data.data)
                //ClearanceNew(0, jmlProd)
            }
        })
    }
    
    const getListSize = async () => {
        try {
            const res = await axios.get(
                "https://hoopsdevteam.com/api_web/controler/rudrunner/listsize.php?index=2"
            );

            if (res.data.state === 200) {
                const sizeList = res.data.data || [];

                const mergedSizes = [
                    ...new Set(
                        sizeList
                            .flatMap(group => group.sizes || [])
                            .map(String)
                    )
                ];

                const convertedSizes = mergedSizes.map(value => {
                    return value.replace(/(\d+)½/g, '$1.5');
                });

                const numericValues = [];
                const nonNumericValues = [];

                convertedSizes.forEach(value => {
                    if (/^\d+(\.\d+)?$/.test(value)) {
                        numericValues.push(parseFloat(value));
                    } else {
                        nonNumericValues.push(value);
                    }
                });

                numericValues.sort((a, b) => a - b);

                const finalResult = [
                    ...numericValues,
                    ...nonNumericValues
                ];

                setListSize(finalResult);

                console.log(finalResult);
            }
        } catch (error) {
            console.error("Failed to get size list:", error);
        }
    };

    useEffect(() => {

        if (isFirstLoad) {
            setIsFirstLoad(false)
            return
        }

        setCurrentPage(0)
        setDisableLoad(false)
        setProducts([])
        setHasMore(true)

        getProductList(
            idCustomer,
            0,
            jmlProd
        )

        setLoadFilter(true)

    }, [filter, sortConfig])

   
    useEffect(() => {
        
        document.title = "Clearance Sale up to 70% Sepatu Running Murah, produk 100% Original & Gratis ongkir se-Indonesia | Rud Runner"
        
        const meta = document.querySelector(
            'meta[name="description"]'
        );

        if (meta) {
            meta.setAttribute(
            "content",
            "Temukan sepatu running murah, apparel, dan aksesoris original dengan harga spesial di Clearance Rud Runner up to 70%. Stok terbatas, jangan sampai kehabisan!"
            );
        }

        // Canonical
        const canonicalUrl = window.location.href.split("?")[0]; // buang query string

        let canonical = document.querySelector("link[rel='canonical']");

        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }

        canonical.setAttribute("href", canonicalUrl);

    }, []);

    
    const [paddingTop, setPaddingTop] = useState(0);

    useEffect(() => {
        
        getListBrandonClearance()
        getListSize()
        
        const updatePadding = () => {
            const topbar =
                document.querySelector(".topbar");

            const navbar =
                document.querySelector(".is-navbar");

            const topbarHeight = topbar?.offsetHeight || 0;
            const navbarHeight = navbar?.offsetHeight || 0;

            setPaddingTop(topbarHeight + navbarHeight - 0.5);

            //console.log('cek topbar : ' , topbarHeight)
            //console.log('cek navbar : ' , navbarHeight)
        };

        updatePadding();

        window.addEventListener("resize", updatePadding);

        return () => window.removeEventListener("resize", updatePadding);
    }, []);

    const toTitleCase = (text) => {
        return text
            ?.toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase())
            .replace(/'(\w)/g, (_, char) => `'${char.toLowerCase()}`);
    };

    

    const handleSearch = async (e) => {
        const keyword = searchVal.trim();
        setFilter({
            search_val: keyword
        })
    }

    return (
        <>
            <section>
                {/* BANNER
                <div className="banner-outer">
                    <div className="banner-inner">
                        <img
                            className="img-fluid d-block w-100"
                            src="https://hoopsdevteam.com/assets/category/main/header/category_65a4fec3090f9.webp"
                            alt="banner"
                        />
                    </div>
                </div> */}
                
                <div className="banner-outer">
                    <div className="banner-inner">
                        { category?.header_image &&
                            <img
                            className="img-fluid d-block w-100"
                            src={category ? category.header_image : directLinkCat ? directLinkCat.header_image : ''}
                            alt="banner"
                            />
                        }
                    </div>
                </div>

                {/* CONTENT */}
                <Container fluid="xl">
                    
                    {isMobile && (
                        <Row className="mt-1" style={{padding: '15px 15px 15px 15px !important'}}>
                            <Col className="text-start col-12">
                                    <Breadcrumb size="tiny">
                                        <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                        <BreadcrumbDivider/>
                                        <BreadcrumbSection active>CLEARANCE PRODUCT</BreadcrumbSection>
                                    </Breadcrumb>
                            </Col>
                        </Row>
                    )}

                    <Row className="mt-5 mb-10">
                        <Col xl={12} lg={12} md={12}>
                            <h1 className="display-5">CLEARANCE</h1>
                            { isMobile ? 
                                (   
                                    <>
                                        <h3 className="fw-light mb-3" style={{ textAlign: 'justify', fontSize: '1em' }}>
                                            Welcome to the Clearance section at Rud Runner. Here you will find a curated selection of running shoes, apparel, accessories, and performance gear from trusted brands including Nike, adidas, ASICS, New Balance, HOKA, Brooks, Saucony, On, and PUMA at special prices. You may discover runner favorites from previous collections, limited-availability products, or selected items offering exceptional value. Every product is 100% Original, so you can shop with confidence and focus on your next goal. Whether you're searching for a great deal or looking to upgrade your running essentials, Rud Runner offers a smart way to get premium running gear for less. Stock changes quickly, so don't miss out.
                                        </h3>
                                        <h3 className="text-uppercase fw-bold" style={{ fontSize: '0.9em' }}>The product might sell out soon, so check out the items you want right away.</h3>
                                    </>
                                ):( 
                                    <>
                                        <h3 className="fs-5 fw-light" style={{textAlign: 'justify'}}>
                                            Welcome to the Clearance section at Rud Runner. Here you will find a curated selection of running shoes, apparel, accessories, and performance gear from trusted brands including Nike, adidas, ASICS, New Balance, HOKA, Brooks, Saucony, On, and PUMA at special prices. You may discover runner favorites from previous collections, limited-availability products, or selected items offering exceptional value. Every product is 100% Original, so you can shop with confidence and focus on your next goal. Whether you're searching for a great deal or looking to upgrade your running essentials, Rud Runner offers a smart way to get premium running gear for less. Stock changes quickly, so don't miss out.
                                        </h3>
                                        <Divider className="mt-5" horizontal><h3 className="fs-6 mt-1">The product might sell out soon, so check out the items you want right away.</h3></Divider>
                                    </>
                            )}
                        </Col>
                    </Row>
                    {/*
                        category?.search_value !== undefined && (
                            <Row className="mb-5">
                                <Col>
                                    <Blog search={category?.search_value ?? null}/>
                                </Col>
                            </Row>
                        )
                    */}
                    <Row className="mt-5 align-items-start" style={{ padding: "0 0rem" }}>
                        {/* LEFT: FILTER */}
                        <Col xl={3} className="filter-sidebar-2" lg={4} md={12}>
                            {
                                <ProductFilterClearance
                                    filter={filter}
                                    setFilter={setFilter}

                                    sortConfig={sortConfig}
                                    setSortConfig={setSortConfig}

                                    colorList={colorList}
                                    brandList={listBrandonClearance}
                                    //sizeList={sizeList}
                                    sizeList={listSize}

                                    searchVal={searchVal}
                                    setSearchVal={setSearchVal}
                                    handleSearch={handleSearch}
                                />
                            }
                        </Col>

                        {/* RIGHT: PRODUCT */}
                        <Col xl={9} lg={8} md={12}>
                            {!isMobile && (
                                    <Row className="mb-3 filter-searchbar" style={{top: `${paddingTop}px`}}>
                                        <Col className="text-start col-6">
                                                <Breadcrumb size="tiny">
                                                    <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                                    <BreadcrumbDivider/>
                                                    <BreadcrumbSection active>CLEARANCE PRODUCT</BreadcrumbSection>
                                                </Breadcrumb>
                                        </Col>
                                        <Col className="text-end col-6">
                                            <FormSuir onSubmit={handleSearch}>
                                                <Popup
                                                    trigger={
                                                    <InputSuir
                                                        value={searchVal}
                                                        onChange={(e) => setSearchVal(e.target.value)}
                                                        icon={{ name: "search", link: true }}
                                                        placeholder="Search in clearance"
                                                    />
                                                    }
                                                    content="Type Name or Article and then press Enter"
                                                />
                                            </FormSuir>
                                        </Col>
                                    </Row>
                                )
                            }

                            <Row className="d-flex justify-content-start mb-3 mt-3">
                            
                            { load && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Loading Products...
                                    </Loader>
                                </Col>
                            )}
                            
                            { loadFilter && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Finding Products...
                                    </Loader>
                                </Col>
                            )}

                            {
                                products?.length > 0 &&
                                products.map((item, i) => {
                                const isWish = wishData.some(w => w.id_product === item.id_product);

                                return (
                                    <ProductCard
                                    data={item}
                                    key={i}
                                    isWish={isWish}
                                    />
                                );
                                })
                            }

                            </Row>

                            {/* LOAD MORE / EMPTY */}
                            <Row className="mt-2">
                            {products.length > 0 ?
                                <Col className="text-center">
                                {
                                    hasMore ?
                                    <div className="pb-2" style={{ height: "20px", textAlign: "center" }}>
                                        {
                                        loaderProduct ?
                                            <Loader active inline size="small" />
                                            :
                                            <Icon name="angle double down" size="big" className="bounce" />
                                        }
                                    </div>
                                    :
                                    <div style={{ height: "20px", textAlign: "center" }}>
                                        <p>All product has been loaded</p>
                                    </div>
                                }
                                </Col>
                                :
                                <>
                                    {(!loadFilter && !load) && (
                                        <Col className="text-center py-5">
                                            <Stack gap={3} className="align-items-center">
                                                <Icon
                                                    name="search"
                                                    size="huge"
                                                    color="grey"
                                                />

                                                <div>
                                                    <h4 className="mb-2">
                                                        Oops! No products found.
                                                    </h4>

                                                    <p className="text-muted mb-0">
                                                        Please try adjusting your search, or feel free to explore our other products.
                                                    </p>
                                                </div>
                                            </Stack>
                                        </Col>
                                    )}
                                </>
                            }
                            </Row>

                        </Col>

                    </Row>
                                    
                    <Row className="mt-5 align-items-start" style={{ padding: "0 2rem" }}>
                        <Col lg={12} md={12} sm={12} className="justify-items-start">
                            <h1 className="fs-5">RUDRUNNER CLEARANCE FOR MEN AND WOMEN PRODUCTS</h1>
                            <h4 className="fw-light mt-0">
                                Welcome to the Clearance section at Rud Runner. Here you will find a curated selection of running shoes, apparel, accessories, and performance gear from trusted brands including Nike, adidas, ASICS, New Balance, HOKA, Brooks, Saucony, On, and PUMA at special prices. You may discover runner favorites from previous collections, limited-availability products, or selected items offering exceptional value. Every product is 100% Original, so you can shop with confidence and focus on your next goal. Whether you're searching for a great deal or looking to upgrade your running essentials, Rud Runner offers a smart way to get premium running gear for less. Stock changes quickly, so don't miss out.
                            </h4>
                        </Col>
                    </Row>
                </Container>
            </section>
            
        </>
    )
}
